// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-red-200-important{color:#fecaca!important}:root .top-bar svg.menu-icon{height:28px!important;width:28px!important}:root .top-bar svg.hamburger-menu path{stroke:#fff!important}:root .top-bar svg.close-menu path{fill:#fff!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
